import { definePanel } from '@/app/definePanel';
import { ObjectsIcon } from '@/components/occurra/icons/ObjectsIcon';

export default definePanel({
    id: 'objects_list',
    title: 'Objects',
    description: 'People, faces and vehicles the agents found. Search them by look.',
    icon: ObjectsIcon,
    // Fixed, not elastic: the gallery keeps the width it was given (its default,
    // or whatever the user dragged it to) instead of re-flowing every time the
    // stage changes size — opening the chat drawer used to resize it on its own.
    // Free width and pressure both land on the fill panel beside it (camera_view);
    // only that panel hitting its own min can take width off this one.
    width: { min: 480, default: 480, max: Infinity, fill: false },
    modes: ['view'], // view-only — switching to settings will auto-close it
    themes: 'any',
    // Custom header (title + search + ×) is rendered inside Panel.jsx to
    // match Figma 561:22859. PanelHost would otherwise stack a generic
    // chrome above it.
    isHeaderless: true,
    // Mutual exclusion with events_list (same "primary list" slot) lives
    // in src/app/exclusions.ts.
    order: 4,
    // AI Search and Enrolled objects take its place in the rail. Where the deployment switches AI
    // Search off, the chat, the area search and "Show similar" open it.
    hasNavButton: false,
    // Filter the gallery to a specific camera when one is selected in the
    // cameras panel / camera_view. Empty → show all cameras in the org.
    urlSyncedProps: ['cameraId'],
});
